import React, {createContext, useReducer} from 'react'
import {AdtfDeviceOverviewReducer} from "../reducer/AdtfDeviceOverviewReducer";

export const AdtfDeviceOverviewContext = createContext();

const AdtfDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        adtfDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true,
        ...props.data
    }
    const [viewModel, dispatch] = useReducer(AdtfDeviceOverviewReducer, data)
    return (
        <AdtfDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AdtfDeviceOverviewContext.Provider>
    )
}

export default AdtfDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/context/AdtfDeviceOverviewContext.js